<template>
  <section
    class="section section-primary is-fullheight animated preFadeInUp fadeInUp"
  >
    <div class="container">
      <!-- Title -->

      <div class="columns is-centered has-text-centered" v-if="requestloading">
        <loading
          line-fg-color="#2d3f51"
          size="massive"
          class="margin-100"
          spacing="55"
          text-fg-color="#fff"
          message="الرجاء الإنتظار"
        />
      </div>

      <div
        class="columns is-vcentered"
        v-else-if="requestsuccess && !otpsuccess"
      >
        <div class="column is-6 is-offset-3 mt-40 mb-40">
          <!-- Login form -->
          <div
            class="flex-card raised padding-20 animated preFadeInUp fadeInUp pb-90"
          >
            <div
              class="square-icon-box rounded info mt-20 animated preFadeInUp fadeInUp"
            >
              <div class="icon-box-wrapper">
                <div class="icon-box">
                  <i class="material-icons">info</i>
                </div>
              </div>
            </div>

            <b-message v-if="!otperrormessage" title="تنبيه" class="pb-10 mt-20"
              >سوف تسلم رسالة نصية تحمل كود التفعيل رجاء ادخال الكود
              بالاسفل</b-message
            >

            <b-message
              v-else
              title="تنبيه"
              type="is-danger"
              class="pb-10 mt-20"
              >{{ errormessage }}</b-message
            >

            <div class="animated preFadeInUp fadeInUp pb-90">
              <hr />
              <form @submit.prevent="sendchangerequest()">
                <div class="field">
                  <div class="control">
                    <input
                      v-model="code"
                      name="code"
                      class="input has-text-centered has-text-black is-large is-english"
                      type="text"
                      placeholder="كود التفعيل"
                      autofocus
                      v-validate="'required|numeric'"
                      :class="{ input: true, 'is-danger': errors.has('code') }"
                    />
                    <span
                      v-show="errors.has('code')"
                      class="help is-danger is-centered"
                      >{{ errors.first("code") }}</span
                    >
                  </div>
                </div>

                <div class="mt-20">
                  <!-- <router-link to="/book" >   <a class="button  is-info is-large is-fullwidth raised "> تأكيد </a></router-link> -->
                  <button
                    class="button is-rounded is-info is-wati is-large is-fullwidth"
                    type="submit"
                    v-bind:class="{ 'is-loading': requestloading }"
                  >
                    تأكيد
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            class="hero-foot has-text-centered mt-20 mb-20 animated preFadeInUp fadeInUp"
          >
            <a
              class="button is-dark btn-align modal-dismiss is-bold is-medium"
              @click="$router.go('-1')"
            >
              <b>العودة</b>
            </a>
          </div>
        </div>
      </div>
      <div
        class="columns is-vcentered"
        v-else-if="!otpsuccess && !requestsuccess"
      >
        <div class="column is-6 is-offset-3 mt-40 mb-90">
          <!-- Login form -->
          <div class="flex-card raised padding-20">
            <div class="square-icon-box rounded danger mt-20">
              <div class="icon-box-wrapper">
                <div class="icon-box">
                  <i class="material-icons">close</i>
                </div>
              </div>
            </div>
            <div class="animated preFadeInLeft fadeInLeft pb-90">
              <hr />
              <h1 class="title is-4 pb-10">فشل في طلب {{ requeststring }}</h1>

              <h1 class="subtitle is-5">{{ errormessage }}</h1>

              <!-- 
                  <h1 class="subtitle is-5">رجاء المحاولة لاحقاً</h1> -->

              <hr />
            </div>
          </div>
          <div
            class="hero-foot has-text-centered mt-20 mb-20 animated preFadeInUp fadeInUp"
          >
            <a
              class="button is-dark btn-align modal-dismiss is-bold is-medium"
              @click="$router.go('-1')"
            >
              <b>العودة</b>
            </a>
          </div>
        </div>
      </div>
      <div
        class="columns is-vcentered"
        v-else-if="otpsuccess && requestsuccess"
      >
        <div class="column is-6 is-offset-3 mt-80 mb-90">
          <!-- Login form -->
          <div
            class="flex-card raised padding-20 animated preFadeInUp fadeInUp pb-90"
          >
            <div
              class="square-icon-box rounded primary mt-20 animated preFadeInUp fadeInUp"
            >
              <div class="icon-box-wrapper">
                <div class="icon-box">
                  <i class="material-icons">check</i>
                </div>
              </div>
            </div>
            <div class="animated preFadeInUp fadeInUp pb-90">
              <hr />
              <h1 class="subtitle is-4 pb-10">
                {{ successmessage }}
              </h1>
            </div>
          </div>
          <div
            class="hero-foot has-text-centered mt-20 mb-20 animated preFadeInUp fadeInUp"
          >
            <a
              class="button is-dark btn-align modal-dismiss is-bold is-medium"
              @click="$router.go('-1')"
            >
              <b>العودة</b>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import arabic from "vee-validate/dist/locale/ar";

export default {
  props: ["requeststring", "requestid", "requesturl"],

  data() {
    return {
      requestloading: true,
      requestsuccess: false,
      otpsuccess: false,
      otperrormessage: false,
      errormessage: "",
      successmessage: "",
      code: "",
      changerequestInfo: { Customer_Id: null, otp: null },
      requestInfo: {
        ServicAction_Id: null,
        Customer_Id: null,
      },
    };
  },
  methods: {
    sendchangerequest() {
      this.requestloading = !this.requestloading;

      var user = JSON.parse(localStorage.getItem("user"));

      this.changerequestInfo.Customer_Id = parseInt(user[1]);

      this.changerequestInfo.token = localStorage.getItem("token");

      this.changerequestInfo.otp = parseInt(this.code);
      console.log("xxxxxxx");

      console.log(this.changerequestInfo);
      console.log("xxxxxxx");

      axios
        .post("mobi/confsub", this.changerequestInfo)
        .then((response) => {
          this.$root.kick(response.data.message);
          console.log(response);
          if (response.data.status == "success") {
            this.successmessage = response.data.message;
            this.otpsuccess = true;
            this.requestsuccess = true;
            this.requestloading = !this.requestloading;
          } else if (response.data.status == "fail") {
            console.log("fail");
            this.code = null;
            this.errormessage = response.data.message;
            this.otperrormessage = true;
            console.log(response.data);
            this.requestloading = !this.requestloading;
          }
        })
        .catch((error) => {
          console.log(error);
          console.log("error");
          console.log(response.data);
          this.requestloading = !this.requestloading;
        });
    },
  },

  created() {
    if (
      this.requeststring == null ||
      this.requestid == null ||
      this.requesturl == null
    ) {
      this.$router.push("/");
    }

    var user = JSON.parse(localStorage.getItem("user"));

    this.requestInfo.Customer_Id = user[1];

    let token = localStorage.getItem("token");
    this.requestInfo.ServicAction_Id = this.requestid;
    console.log(this.requestInfo);
    axios
      .post(this.requesturl, this.requestInfo)
      .then((response) => {
        this.$root.kick(response.data.message);

        if (response.data.status === "success") {
          this.requestloading = !this.requestloading;
          this.requestsuccess = !this.requestsuccess;

          // alert("request sent successfully");
        } else if (response.data.status === "fail") {
          this.requestloading = !this.requestloading;
          this.requestsuccess = false;
          console.log(response.data.message);
          this.errormessage = response.data.message;
          // alert("request fail");
        }
      })
      .catch((error) => {
        this.isLoading = !this.isLoading;
        this.message = true;
      });
  },
};
</script>
